import { render, staticRenderFns } from "./PanelHome.vue?vue&type=template&id=32766128"
import script from "./PanelHome.vue?vue&type=script&lang=ts"
export * from "./PanelHome.vue?vue&type=script&lang=ts"
import style0 from "./PanelHome.vue?vue&type=style&index=0&id=32766128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports